import { Stack, Typography, useTheme } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { forwardRef } from "react";

const getStyles = (theme, neutral) => ({
  filled: {
    width: "100%",
    borderRadius: "5px",
    "& .MuiInputBase-root": {
      backgroundColor: neutral ? "neutral.main" : "secondary.main",
      "&.Mui-disabled": {
        backgroundColor: neutral
          ? theme?.palette?.neutral?.light || "#f5f5f5"
          : theme?.palette?.secondary?.light || "#e0e0e0",
        color: theme?.palette?.text?.disabled || "#9e9e9e"
      }
    },
    "& .MuiInputBase-input": {
      padding: "8px 16px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `none`
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`
      }
    },
    "&.Mui-disabled": {
      "& .MuiInputBase-input": {
        WebkitTextFillColor: theme?.palette?.text?.disabled || "#9e9e9e"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme?.palette?.grey?.[300] || "#d1d5db"
      }
    }
  },
  outlined: {
    width: "100%",
    borderRadius: "5px",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: neutral ? "neutral.dark" : "primary.main"
      },
      "&:hover fieldset": {
        borderColor: neutral ? "neutral.dark" : "primary.main"
      },
      "&.Mui-focused fieldset": {
        borderColor: neutral ? "neutral.dark" : "primary.main"
      },
      "&.Mui-disabled": {
        backgroundColor: neutral
          ? theme?.palette?.neutral?.light || "#f5f5f5"
          : theme?.palette?.grey?.[100] || "#f5f5f5",
        "& fieldset": {
          borderColor: theme?.palette?.grey?.[300] || "#d1d5db"
        },
        "& .MuiInputBase-input": {
          WebkitTextFillColor: theme?.palette?.text?.disabled || "#9e9e9e"
        }
      }
    }
  },
  "& .MuiInputBase-input": {
    padding: "8px 16px"
  }
});

export const PhoneInputField = forwardRef(
  (
    {
      label,
      isLabelBold,
      variant = "outlined",
      neutral,
      error,
      helperText,
      required,
      ...rest
    },
    ref
  ) => {
    const theme = useTheme();
    const styles = getStyles(theme, neutral);

    return (
      <Stack width="100%">
        {!!label && (
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: isLabelBold && 700,
              "&:after": {
                content: required ? '" *"' : '""',
                color: "red"
              }
            }}
          >
            {label}
          </Typography>
        )}
        <MuiTelInput
          error={error}
          helperText={helperText}
          forceCallingCode
          defaultCountry="ET"
          disableFormatting
          size="small"
          sx={styles[variant]}
          inputRef={ref}
          inputProps={{
            maxLength: 13
          }}
          {...rest}
        />
      </Stack>
    );
  }
);

PhoneInputField.displayName = "PhoneInputField";
